import { EntityPresenterV2Mode, isStaticMode } from './presenterV2EntityMode';

import type { Maybe } from '@nova/core';
import type { PresenterPlaceholderData } from './presenterV2Placeholder';
import type { YardAreaDetails } from './useYardAreaPresenterV2';
import type { YardSpotDetails } from './yardSpotPresenterV2Shared';

export function nestedSpotPresenterDataProps(
  mode: EntityPresenterV2Mode,
  data: {
    spot?: Maybe<YardSpotDetails | PresenterPlaceholderData<YardSpotDetails>>;
    spotArea?: Maybe<YardAreaDetails | PresenterPlaceholderData<YardAreaDetails>>;
  }
) {
  if (isStaticMode(mode)) {
    return {
      staticSpotData: (data.spot ?? null) as Maybe<YardSpotDetails>,
      staticAreaData: (data.spotArea ?? null) as Maybe<YardAreaDetails>
    };
  }

  return {
    placeholderSpotData: (data.spot ?? null) as Maybe<PresenterPlaceholderData<YardSpotDetails>>,
    placeholderAreaData: (data.spotArea ?? null) as Maybe<PresenterPlaceholderData<YardAreaDetails>>
  };
}
